import { render, staticRenderFns } from "./ti3.vue?vue&type=template&id=0cfac201&scoped=true&"
import script from "./ti3.vue?vue&type=script&lang=js&"
export * from "./ti3.vue?vue&type=script&lang=js&"
import style0 from "./ti3.vue?vue&type=style&index=0&id=0cfac201&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfac201",
  null
  
)

export default component.exports